// extracted by mini-css-extract-plugin
module.exports = {"NewPatternConsequenceBlock":"NewPatternConsequence_NewPatternConsequenceBlock__c0pvS"};